import { Component, OnInit, TemplateRef, viewChild, inject } from '@angular/core';
import {
  BrowserMessagesService,
  ModalRef,
  ModalService,
  TableColumn,
  TableComponent,
  LoaderComponent, SideMenuHeadlineComponent
} from '@rbb/ng-web-template-lib';
import { FormGroup } from '../../data/form-group';
import { FormGroupService } from '../../services/form-group.service';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-form-groups',
  templateUrl: './form-groups.component.html',
  styleUrls: ['./form-groups.component.css'],
  imports: [RouterLink, TableComponent, LoaderComponent, SideMenuHeadlineComponent]
})
export class FormGroupsComponent implements OnInit {
  private formGroupService = inject(FormGroupService);
  private browserMessagesService = inject(BrowserMessagesService);
  private modalService = inject(ModalService);

  formGroups: FormGroup[] | undefined;
  selectedID: string | undefined;

  columns: TableColumn[] = [
    { name: 'Name', field: 'name', type: 'string' },
    { name: 'Sichtbar', field: 'hide', type: 'boolean' },
    { name: '', field: 'edit', type: null },
    { name: '', field: 'delete', type: null }
  ];

  readonly ngModal = viewChild<TemplateRef<unknown>>('ngModal');
  ngModalService: ModalRef<unknown> | undefined;

  ngOnInit(): void {
    this.getFormGroups();
  }

  getFormGroups(): void {
    this.formGroupService.getFormGroups().subscribe({
      next: (next) => {
        this.formGroups = next;
      },
      error: (error) => {
        this.browserMessagesService.showHttpError(error, 'Formulargruppen konnten nicht geladen werden');
      }
    });
  }

  deleteFormGroup(): void {
    if (this.selectedID) {
      this.formGroupService.deleteFormGroup(this.selectedID).subscribe({
        next: () => {
          this.closeModal();
          this.getFormGroups();
        },
        error: (error) => {
          this.browserMessagesService.showHttpError(error, 'Formulargruppe konnte nicht gelöscht werden');
        }
      });
    }
  }

  openModal(id: string): void {
    this.selectedID = id;
    const ngModal = this.ngModal();
    if (ngModal) {
      this.ngModalService = this.modalService.open(ngModal, { centered: true, backdrop: 'static' });
    }
  }

  closeModal(): void {
    this.ngModalService?.close();
  }
}
